import React, { useContext, useMemo } from 'react';
import { FilterDeepContext } from '@opm/components/FilterCommon/state';
import FilterCommon, { useFilterCommon } from '@opm/components/FilterCommon';
import moment, { Moment } from 'moment';

const filterOptions = {
  7: {
    date: { value: 'date', text: '7Days', text_cn: ' 7天' },
  },
  30: {
    date: { value: 'date', text: '30Days', text_cn: ' 30天' },
  },
};

interface ITrendFilterProps {
  filterValue: Array<string>;
  change: (value: { start_time: string; end_time: string }) => void;
  num: 7 | 30;
  firstAvailableTime?: string;
  instanceId: string;
}

export default function TrendFilter({
  filterValue,
  change,
  num,
  firstAvailableTime,
  instanceId,
}: ITrendFilterProps) {
  const { filter, setFilter, ...filterProps } = useFilterCommon({
    keys: ['MultiDateRange', 'HashtagCountryRegion'],
    instanceId,
  });

  const { backCondConfig } = useContext(FilterDeepContext);

  // 禁用早于 first_available_time 的日期
  // 注意：返回 true 表示可选，false 表示禁用
  const disabledDateFunc = useMemo(
    () =>
      (date: Moment): boolean => {
        if (!firstAvailableTime) {
          return true; // 如果没有限制，全部可选
        }
        const firstDate = moment(firstAvailableTime, 'YYYY-MM-DD');
        // 如果日期早于 first_available_time，返回 false（禁用）
        // 否则返回 true（可选）
        return !date.isBefore(firstDate, 'day');
      },
    [firstAvailableTime],
  );

  const disabledDate = useMemo(
    () => ({
      date: disabledDateFunc,
    }),
    [disabledDateFunc],
  );

  return (
    <div className="dbom-hashtag-trend-filter">
      <FilterCommon
        {...filterProps}
        realTimeMode
        userDefaultValue={filterValue}
        createShortId={false}
        saveStorage={false}
        extrRequestKeys={['marketing_hub_hashtag_config_time_range_category']}
        confirm={(value: any) => change(value)}
        backCondConfig={backCondConfig}
        finallyDealwithDefaultValue={(value) => {
          return {
            ...value,
            ...filterValue,
          };
        }}
        filterConfigProps={{
          MultiDateRange: {
            optionsMap: filterOptions[num],
            disabledDate,
          },
        }}
      ></FilterCommon>
    </div>
  );
}
